import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'buscar-asignaturas-pensum',
  template: `
    <div class="row">
      <div class="col-sm-4">
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-addon ">
            Buscar
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Filtrar"
            [(ngModel)]="search"
            >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2" *ngFor="let item of materias | filterBy:['aca_asignatura_descripcion','aca_curso_especialidad_abreviatura','aca_curso_nivel_descripcion','aca_docente_descripcion','aca_curso_nivel_abreviatura']: search"  >
          <div  
            class="card" 
            (click)="selectPensum(item)"
            style="cursor: pointer;">
            <div class="card-block text-center p-0">
              <div class="feature-icon f-30 text-white pt-3" [ngStyle]="{'background-color':item.aca_asignatura_color}">
                <i class="ti-ruler-pencil border border-white rounded" style="padding:12px" ></i>
                <h4 class="f-14 mt-2 pb-2"  style="font-weight: 600;">
                  {{item.aca_curso_nivel_abreviatura}} {{item.aca_curso_especialidad_abreviatura}} "{{item.aca_curso_paralelo_abreviatura}}"
                </h4>
              </div>
              <h4 class="f-12 mt-2" style="font-weight: 600;" >
                {{item.aca_asignatura_descripcion}}
              </h4>
              
            </div>
            <div class="card-footer pb-1 pt-0 pl-1 pr-1" [hidden]="!activarDocente">
             <p class="p-0 m-0 text-center" style="color:#1c6ea0; font-size:9.2px">{{item.aca_docente_descripcion}}</p>
            </div>
          </div>
      </div>
    </div>
  `,
  styles: []
})
export class BuscarAsignaturasPensumComponent implements OnInit {
  @Input() materias
  @Input() activarDocente  = false
  @Output() emitterPensum  = new EventEmitter()
  search:any
  constructor() { }

  ngOnInit() {

  }

  selectPensum(pensum){
    this.emitterPensum.emit(pensum)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/buscar-asignaturas-pensum.component.ts